function bind(el, binding) {
  el.sivOnScroll = () => {
    if (typeof binding.value.cb == 'function') {
      var rect = el.getBoundingClientRect();
      var offset = {
        x: 0,
        y:
          Math.abs(0.5 * window.innerHeight - rect.top - 0.5 * rect.height) /
          (0.5 * window.innerHeight)
      };

      if (offset.y <= binding.value.threshold) {
        binding.value.cb();
        window.removeEventListener('scroll', el.sivOnScroll);

        el.sivOnScroll = null;
      }
    }
  };

  window.addEventListener('scroll', el.sivOnScroll);

  setTimeout(el.sivOnScroll);
}

function unbind(el) {
  if (!!el.sivOnScroll) {
    window.removeEventListener('scroll', el.sivOnScroll);
  }
}

export default { bind, unbind };



// WEBPACK FOOTER //
// ./src/directives/scroll-into-view.js